<div class="table-responsive shadow">
  <table mat-table [dataSource]="table.dataSource()" multiTemplateDataRows matSort (matSortChange)="table.sortState.set($event)">
    @for (c of table.config(); track c.columnDef) {
      <ng-container [matColumnDef]="c.columnDef">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ c.header }}</th>
        <td mat-cell *matCellDef="let row">
          @if (c.type === "boolean") {
            <mat-checkbox [checked]="row[c.property]" disabled="true"></mat-checkbox>
          } @else {
            @if (c.onClick) {
              <div (click)="c.onClick(row)" class="pointer">{{ table.formatValue(row, c) }}</div>
            } @else {
              {{ table.formatValue(row, c) }}
            }
          }
        </td>
      </ng-container>
    }
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row" width="180">
        <button class="btn" (click)="updateBranch(row)" title="Edit Business Branch"><i class="fas fa-pencil-alt text-secondary"></i></button>
        <button class="btn" (click)="addLicense(row)" title="Add License"><i class="fas fa-plus text-secondary"></i></button>
      </td>
    </ng-container>
    <!-- <ng-container matColumnDef="details">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns().length">
      @for (l of row.Licenses; track l.Id) {
        <div class="px-3 detail-row d-grid grid-3-col">
          <div class="">Validity: {{ l.ValidSince | date: 'dd MMM yyyy' }} - {{ l.ValidUntil | date: 'dd MMM yyyy' }}</div>
          <div>{{ l.Remark }}</div>
          <div><button class="btn" (click)="updateBranch(row)" title="Edit"><i class="fas fa-pencil-alt text-secondary"></i></button></div>
        </div>
      }
      </td>
    </ng-container> -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()" [class.bg-danger-subtle]="row.ActiveLicenseCount === 0"></tr>
    <!-- <tr mat-row *matRowDef="let row; columns: ['details']"></tr> -->
  </table>
</div>
